import { default as ChevronRightIconMUI } from '@mui/icons-material/ChevronRight';

export const ChevronRightIcon = ChevronRightIconMUI;
